module.exports = __webpack_public_path__ + "img/chinesecompany75.0f925a2a.png";